import React from "react"
import { Link as GatsbyLink } from "gatsby"
import { useTranslation } from "react-i18next"

import { localizeUrl } from "../../../utils/i18n"

export default function Link({ to, ...props }) {
  const { t } = useTranslation()

  return <GatsbyLink to={localizeUrl(t, { url: to })} {...props} />
}
